import { Injectable } from '@angular/core';
import { RestApiService } from '../../../../src/app/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class EuttcProposalService {

  constructor(public api: RestApiService) { }

  /*** Apply online form submit **/
  submitData(data) {
    return this.api.postDirect("/saveCoeApplyonlineProposal", data);
  }

  submitStep1Data(data) {
    return this.api.postDirect("/saveEuttcApplicationStep1", data);
  }

  submitStep2Data(data) {
    return this.api.postDirect("/saveCoeApplicationStep2", data);
  }

  submitStep3Data(data) {
    return this.api.postDirect("/saveApplicationStep3", data);
  }

  submitStep4Data(data) {
    return this.api.postDirect("/saveApplicationStep4", data);
  }

  /*** Get Apply online form detil **/
  getCoeApplicationDetail(applictionID) {
    return this.api.postDirect("/editCoeApplicationDetails", applictionID);
  }
  
}

